import { httpRequest } from '@/request/utils/httprequest.js'
import baseUrl from '@/request/base.js'
import { baseconfig, rsaBasicModuleConfig } from '@/config.js'
import { rsa } from '@/tools/encrypt.js'
import { publicFun } from '@/tools/time.js'
import store from '@/store'
import qs from 'qs'
//说明设置
export const explainModule = {
    // /getexplainsettinglistbypage --说明设置列表 --jwj
    async getexplainsettinglistbypage(page_index, page_size) {
        const adminToken = store.getters.adminID
        var paras = {
            timestamp: rsa.encryptString(String(publicFun.gettimestamp()), rsaBasicModuleConfig.serverPublicKey),
            _sign: rsa.signString(baseconfig.v + adminToken + String(page_index) + String(page_size) + '~ACf', rsaBasicModuleConfig.clientPrivateKey),
        }
        console.log(baseconfig.v + adminToken + String(page_index) + String(page_size) + '~ACf')
        return await httpRequest(baseUrl.basic + 'explainsettinglist?timestamp=' + encodeURIComponent(paras.timestamp) + '&_sign=' + encodeURIComponent(paras._sign) + '&page_index=' + page_index + '&page_size=' + page_size, 'get', null, null);
    },
    // /getexplainsettingmodel --获取说明设置详情 --jwj
    async getexplainsettingmodel(explain_id) {
        const adminToken = store.getters.explain_id
        var paras = {
            explain_id: explain_id,
            timestamp: rsa.encryptString(String(publicFun.gettimestamp()), rsaBasicModuleConfig.serverPublicKey),
            _sign: rsa.signString(baseconfig.v + String(explain_id) + '~ACf', rsaBasicModuleConfig.clientPrivateKey),
        }
        return await httpRequest(baseUrl.basic + 'explainsettinginfo?timestamp=' + encodeURIComponent(paras.timestamp) + '&_sign=' + encodeURIComponent(paras._sign) + '&explain_id=' + explain_id, 'get', null, null);
    },
    // /editexplainsetting --编辑说明设置 --jwj
    async editexplainsetting(explain_id, explain_content) {
        const adminToken = store.getters.adminID
        var paras = {
            explain_id: explain_id,
            explain_content: explain_content,
            timestamp: rsa.encryptString(String(publicFun.gettimestamp()), rsaBasicModuleConfig.serverPublicKey),
            _sign: rsa.signString(baseconfig.v + adminToken + String(explain_id) + explain_content + '~ACf', rsaBasicModuleConfig.clientPrivateKey),
        }
        console.log('editexplainsetting', paras)
        return await httpRequest(baseUrl.basic + 'editexplainsetting', 'post', qs.stringify(paras), null);
    },
}

//地区管理
export const regionModule = {
    // 行政区划下拉框
    async regioninfogetlist(region_level, p_region_id) {
        const adminToken = store.getters.adminID
        var paras = {
            timestamp: rsa.encryptString(String(publicFun.gettimestamp()), rsaBasicModuleConfig.serverPublicKey),
            _sign: rsa.signString(baseconfig.v + adminToken + String(region_level) + String(p_region_id) + '~H123asd', rsaBasicModuleConfig.clientPrivateKey),
        }
        return await httpRequest(baseUrl.basic + 'regioninfogetlist?timestamp=' + encodeURIComponent(paras.timestamp) + '&_sign=' + encodeURIComponent(paras._sign) + '&region_level=' + region_level + '&p_region_id=' + p_region_id, 'get', null, null)
    },
    // 行政区划列表
    async regioninfolist(page, pagesize, p_region_level, p_region_id) {
        const adminToken = store.getters.adminID
        var paras = {
            timestamp: rsa.encryptString(String(publicFun.gettimestamp()), rsaBasicModuleConfig.serverPublicKey),
            _sign: rsa.signString(baseconfig.v + adminToken + String(p_region_level) + String(p_region_id) + '~Hasfd', rsaBasicModuleConfig.clientPrivateKey),
        }
        return await httpRequest(baseUrl.basic + 'regioninfolist?timestamp=' + encodeURIComponent(paras.timestamp) + '&_sign=' + encodeURIComponent(paras._sign) + '&page=' + page + '&pagesize=' + pagesize + '&p_region_level=' + p_region_level + '&p_region_id=' + p_region_id, 'get', null, null)
    },
    // 行政区划详情
    async regioninfo(region_level, base_region_id) {
        const adminToken = store.getters.adminID
        var paras = {
            timestamp: rsa.encryptString(String(publicFun.gettimestamp()), rsaBasicModuleConfig.serverPublicKey),
            _sign: rsa.signString(baseconfig.v + adminToken + String(region_level) + '~Hasfd', rsaBasicModuleConfig.clientPrivateKey)
        }
        return await httpRequest(baseUrl.basic + 'regioninfo?timestamp=' + encodeURIComponent(paras.timestamp) + '&_sign=' + encodeURIComponent(paras._sign) + '&region_level=' + region_level + '&base_region_id=' + base_region_id, 'get', null, null);
    },
    //删除行政区划--HYT
    async delregioninfo(region_level, base_region_id) {
        const adminToken = store.getters.adminID
        var paras = {
            region_level: region_level,
            base_region_id: base_region_id,
            timestamp: rsa.encryptString(String(publicFun.gettimestamp()), rsaBasicModuleConfig.serverPublicKey),
            // (v + AdminToken + explainID  + "~ACf")
            _sign: rsa.signString(baseconfig.v + adminToken + String(base_region_id) + 'djsej@2dfs', rsaBasicModuleConfig.clientPrivateKey),
        }
        return await httpRequest(baseUrl.basic + 'delregioninfo', 'post', qs.stringify(paras), null)
    },
    // 编辑行政区划
    async editregioninfo(region_level, base_region_id, base_region_sn, base_region_name, base_region_abbreviation, manage_type, original_value_json) {
        const adminToken = store.getters.adminID
        var paras = {
            region_level: region_level,
            base_region_id: base_region_id,
            base_region_sn: base_region_sn,
            base_region_name: base_region_name,
            base_region_abbreviation: base_region_abbreviation,
            manage_type: manage_type,
            original_value_json: original_value_json,
            timestamp: rsa.encryptString(String(publicFun.gettimestamp()), rsaBasicModuleConfig.serverPublicKey),
            _sign: rsa.signString(baseconfig.v + adminToken + String(region_level) + String(base_region_id) + '~ASD123324', rsaBasicModuleConfig.clientPrivateKey)
        }
        return await httpRequest(baseUrl.basic + 'editregioninfo', 'post', qs.stringify(paras), null)
    },
    // 添加行政区划
    async addregioninfo(region_level, base_region_id, base_region_sn, base_region_name, base_region_abbreviation, manage_type, is_province, p_region_id, p_region_level) {
        const adminToken = store.getters.adminID
        var paras = {
            region_level: region_level,
            base_region_id: base_region_id,
            base_region_sn: base_region_sn,
            base_region_name: base_region_name,
            base_region_abbreviation: base_region_abbreviation,
            manage_type: manage_type,
            p_region_id: p_region_id,
            p_region_level: p_region_level,
            is_province: is_province,
            timestamp: rsa.encryptString(String(publicFun.gettimestamp()), rsaBasicModuleConfig.serverPublicKey),
            _sign: rsa.signString(baseconfig.v + adminToken + String(region_level) + String(base_region_id) + String(p_region_id) + String(p_region_level) + String(is_province) + 'asdaM|', rsaBasicModuleConfig.clientPrivateKey)

        }
        return await httpRequest(baseUrl.basic + 'addregioninfo', 'put', qs.stringify(paras), null)
    },
    //禁用启用行政区划
    async logoutregioninfo(region_level, base_region_id, logout_status) {
        const adminToken = store.getters.adminID
        var paras = {
            region_level: region_level,
            base_region_id: base_region_id,
            logout_status: logout_status,
            timestamp: rsa.encryptString(String(publicFun.gettimestamp()), rsaBasicModuleConfig.serverPublicKey),
            _sign: rsa.signString(baseconfig.v + adminToken + String(base_region_id) + String(logout_status) + '~zxvaZFD1', rsaBasicModuleConfig.clientPrivateKey),
        }
        return await httpRequest(baseUrl.basic + 'logoutregioninfo', 'post', qs.stringify(paras), null)
    },

    // 生成账号
    async addAccount(login_name, region_level, region_id, admin_unit_name) {
        const adminToken = store.getters.adminID
        var paras = {
            login_name: login_name,
            region_level: region_level,
            region_id: region_id,
            admin_unit_name: admin_unit_name,
            timestamp: rsa.encryptString(String(publicFun.gettimestamp()), rsaBasicModuleConfig.serverPublicKey),
            _sign: rsa.signString(baseconfig.v + adminToken + String(region_level) + String(region_id) + 'dsD43#AdwCf', rsaBasicModuleConfig.clientPrivateKey),
        }
        return await httpRequest(baseUrl.basic + 'newregionadminadd', 'put', qs.stringify(paras), null)
    },
}
export const equipmentallocationusequeryModule = {

}
export const loginfoModule = {
    // 日志列表
    async loginfolist(page, pagesize, key_words) {
        const adminToken = store.getters.adminID
        var paras = {
            timestamp: rsa.encryptString(String(publicFun.gettimestamp()), rsaBasicModuleConfig.serverPublicKey),
            _sign: rsa.signString(baseconfig.v + adminToken + '~OIDSAFH', rsaBasicModuleConfig.clientPrivateKey),
        }
        return await httpRequest(baseUrl.basic + 'loginfolist?timestamp=' + encodeURIComponent(paras.timestamp) + '&_sign=' + encodeURIComponent(paras._sign) + '&page=' + page + '&pagesize=' + pagesize + '&key_words=' + key_words, 'get', null, null)
    },
}
export const systemcodeModule = {
    // 系统编码列表
    async systemcodeinfogetlist(mark, policy_measure_id) {
        const adminToken = store.getters.adminID
        var paras = {
            timestamp: rsa.encryptString(String(publicFun.gettimestamp()), rsaBasicModuleConfig.serverPublicKey),
            _sign: rsa.signString(baseconfig.v + adminToken + String(mark) + '~HqFQd', rsaBasicModuleConfig.clientPrivateKey),
        }
        return await httpRequest(baseUrl.basic + 'systemcodeinfogetlist?timestamp=' + encodeURIComponent(paras.timestamp) + '&_sign=' + encodeURIComponent(paras._sign) + '&mark=' + mark + '&policy_measure_id=' + policy_measure_id, 'get', null, null)
    },
    // 系统编码列表
    async systemcodeinfolist(page, pagesize, mark) {
        const adminToken = store.getters.adminID
        var paras = {
            timestamp: rsa.encryptString(String(publicFun.gettimestamp()), rsaBasicModuleConfig.serverPublicKey),
            _sign: rsa.signString(baseconfig.v + adminToken + String(mark) + '~Hasfd', rsaBasicModuleConfig.clientPrivateKey),
        }
        return await httpRequest(baseUrl.basic + 'systemcodeinfolist?timestamp=' + encodeURIComponent(paras.timestamp) + '&_sign=' + encodeURIComponent(paras._sign) + '&page=' + page + '&pagesize=' + pagesize + '&mark=' + mark, 'get', null, null)
    },
    //系统编码详情
    async systemcodeinfo(systemcode_id, mark) {
        const adminToken = store.getters.adminID
        var paras = {
            timestamp: rsa.encryptString(String(publicFun.gettimestamp()), rsaBasicModuleConfig.serverPublicKey),
            // （v + AdminToken + notice_id + "~ACf" ）
            _sign: rsa.signString(baseconfig.v + adminToken + String(systemcode_id) + '~J(l1I9', rsaBasicModuleConfig.clientPrivateKey)
        }
        return await httpRequest(baseUrl.basic + 'systemcodeinfo?timestamp=' + encodeURIComponent(paras.timestamp) + '&_sign=' + encodeURIComponent(paras._sign) + '&mark=' + mark + '&systemcode_id=' + systemcode_id, 'get', null, null);
    },
    //添加系统编码
    async addsystemcodeinfo(mark, systemcode_name, is_enter, order_weight) {
        const adminToken = store.getters.adminID
        var paras = {
            mark: mark,
            systemcode_name: systemcode_name,
            is_enter: is_enter,
            order_weight: order_weight,
            timestamp: rsa.encryptString(String(publicFun.gettimestamp()), rsaBasicModuleConfig.serverPublicKey),
            // (v + AdminToken + noticetitle + noticedesc + orderweight + "~ACf")
            _sign: rsa.signString(baseconfig.v + adminToken + String(mark) + String(is_enter) + String(order_weight) + '!tTaM|', rsaBasicModuleConfig.clientPrivateKey)

        }
        return await httpRequest(baseUrl.basic + 'addsystemcodeinfo', 'put', qs.stringify(paras), null)
    },
    // 编辑系统编码
    async editsystemcodeinfo(mark, systemcode_id, systemcode_name, is_enter, order_weight, original_value_json) {
        const adminToken = store.getters.adminID
        var paras = {
            mark: mark,
            systemcode_id: systemcode_id,
            systemcode_name: systemcode_name,
            is_enter: is_enter,
            order_weight: order_weight,
            original_value_json: original_value_json,
            timestamp: rsa.encryptString(String(publicFun.gettimestamp()), rsaBasicModuleConfig.serverPublicKey),
            _sign: rsa.signString(baseconfig.v + adminToken + String(mark) + String(systemcode_id) + String(is_enter) + String(order_weight) + '~ASDLN1324', rsaBasicModuleConfig.clientPrivateKey)
        }
        return await httpRequest(baseUrl.basic + 'editsystemcodeinfo', 'post', qs.stringify(paras), null)
    },
    //禁用启用系统编码
    async logoutsystemcodeinfo(mark, systemcode_id, logout_status) {
        const adminToken = store.getters.adminID
        var paras = {
            mark: mark,
            systemcode_id: systemcode_id,
            logout_status: logout_status,
            timestamp: rsa.encryptString(String(publicFun.gettimestamp()), rsaBasicModuleConfig.serverPublicKey),
            // (v + AdminToken + explainID  + "~ACf")
            _sign: rsa.signString(baseconfig.v + adminToken + String(systemcode_id) + String(logout_status) + '~zxvaZFD1', rsaBasicModuleConfig.clientPrivateKey),
        }
        return await httpRequest(baseUrl.basic + 'logoutsystemcodeinfo', 'post', qs.stringify(paras), null)
    },
    ///systemregionlevelgetlist 出台级别下拉框
    async systemregionlevelgetlist(mark) {
        const adminToken = store.getters.adminID
        var paras = {
            timestamp: rsa.encryptString(String(publicFun.gettimestamp()), rsaBasicModuleConfig.serverPublicKey),
            _sign: rsa.signString(baseconfig.v + adminToken + mark + '~HqFQd', rsaBasicModuleConfig.clientPrivateKey),
        }
        return await httpRequest(baseUrl.basic + 'systemregionlevelgetlist?timestamp=' + encodeURIComponent(paras.timestamp) + '&_sign=' + encodeURIComponent(paras._sign) + '&mark=' + mark, 'get', null, null)
    },
    //删除系统编码--HYT
    async delsystemcodeinfo(mark, systemcode_id) {
        const adminToken = store.getters.adminID
        var paras = {
            mark: mark,
            systemcode_id: systemcode_id,
            timestamp: rsa.encryptString(String(publicFun.gettimestamp()), rsaBasicModuleConfig.serverPublicKey),
            // (v + AdminToken + explainID  + "~ACf")
            _sign: rsa.signString(baseconfig.v + adminToken + String(systemcode_id) + 'djsej@2dfs', rsaBasicModuleConfig.clientPrivateKey),
        }
        return await httpRequest(baseUrl.basic + 'delsystemcodeinfo', 'post', qs.stringify(paras), null)
    },
}
// 公告管理
export const noticeModule = {
    // 获取公告列表
    async getNoticeList(page, page_size, notice_title, notice_type) {
        const adminToken = store.getters.adminID
        var paras = {
            timestamp: rsa.encryptString(String(publicFun.gettimestamp()), rsaBasicModuleConfig.serverPublicKey),
            // v +AdminToken +notice_type + MKBPLDNB
            _sign: rsa.signString(baseconfig.v + adminToken + notice_type + "MKBPLDNB", rsaBasicModuleConfig.clientPrivateKey),
        }
        return await httpRequest(baseUrl.basic + 'noticeinfolist?page=' + page + '&age_size=' + page_size + '&notice_title=' + notice_title + '&notice_type=' + notice_type + '&timestamp=' + encodeURIComponent(paras.timestamp) + '&_sign=' + encodeURIComponent(paras._sign), 'get', null, null)
    },
    // 获取公告内容详情
    async getNoticeContents(notice_id) {
        const adminToken = store.getters.adminID
        var paras = {
            timestamp: rsa.encryptString(String(publicFun.gettimestamp()), rsaBasicModuleConfig.serverPublicKey),
            // v +AdminToken+notice_id + ddsfgh8JK  
            _sign: rsa.signString(baseconfig.v + adminToken + notice_id + 'ddasd', rsaBasicModuleConfig.clientPrivateKey)
        }
        // console.log(paras)
        return await httpRequest(baseUrl.basic + 'noticecontent?notice_id=' + notice_id + '&timestamp=' + encodeURIComponent(paras.timestamp) + '&_sign=' + encodeURIComponent(paras._sign), 'get', null, null)
    },
    // 获取公告详情
    async getNoticeDetails(notice_id) {
        const adminToken = store.getters.adminID
        var paras = {
            timestamp: rsa.encryptString(String(publicFun.gettimestamp()), rsaBasicModuleConfig.serverPublicKey),
            // v +AdminToken+notice_id + ddsfgh8JK  
            _sign: rsa.signString(baseconfig.v + adminToken + notice_id + 'ddsfgh8JK', rsaBasicModuleConfig.clientPrivateKey)
        }
        // console.log(paras)
        return await httpRequest(baseUrl.basic + 'noticeinfomodel?notice_id=' + notice_id + '&timestamp=' + encodeURIComponent(paras.timestamp) + '&_sign=' + encodeURIComponent(paras._sign), 'get', null, null)
    },
    // 公告添加
    async addNotice(notice_title, notice_type, notice_content, file_info) {
        const adminToken = store.getters.adminID
        var paras = {
            notice_title: notice_title,
            notice_type: notice_type,
            notice_content: notice_content,
            file_info: file_info,
            timestamp: rsa.encryptString(String(publicFun.gettimestamp()), rsaBasicModuleConfig.serverPublicKey),
            //v +AdminToken+notice_type+ jyrd43FF
            _sign: rsa.signString(baseconfig.v + adminToken + notice_type + "jyrd43FF", rsaBasicModuleConfig.clientPrivateKey)
        }
        console.log(baseconfig.v + adminToken + notice_type + "jyrd43FF")
        return await httpRequest(baseUrl.basic + 'addnoticeinfo', 'put', qs.stringify(paras), null)
    },
    //公告编辑
    async editNotice(notice_id, notice_title, notice_type, notice_content, file_info, original_value_json) {
        const adminToken = store.getters.adminID
        var paras = {
            notice_id: notice_id,
            notice_title: notice_title,
            notice_type: notice_type,
            notice_content: notice_content,
            file_info: file_info,
            original_value_json: original_value_json,
            timestamp: rsa.encryptString(String(publicFun.gettimestamp()), rsaBasicModuleConfig.serverPublicKey),
            // v +AdminToken+notice_id+notice_type+ jfhr43FF 
            _sign: rsa.signString(baseconfig.v + adminToken + String(notice_id) + String(notice_type) + 'jfhr43FF', rsaBasicModuleConfig.clientPrivateKey)
        }
        return await httpRequest(baseUrl.basic + 'editnoticeinfo', 'post', qs.stringify(paras), null)
    },
    //公告删除
    async delNotice(notice_id) {
        const adminToken = store.getters.adminID
        var paras = {
            notice_id: notice_id,
            timestamp: rsa.encryptString(String(publicFun.gettimestamp()), rsaBasicModuleConfig.serverPublicKey),
            // v +AdminToken+notice_id+ MBIM#N58ndks 
            _sign: rsa.signString(baseconfig.v + adminToken + String(notice_id) + 'MBIM#N58ndks', rsaBasicModuleConfig.clientPrivateKey)
        }
        return await httpRequest(baseUrl.basic + 'delnoticeinfo', 'post', qs.stringify(paras), null)
    },
}
// 系统消息
export const systemMessageModule = {
    // 获取系统消息
    async systemmessageinfolist(page, pagesize, key_words) {
        const adminToken = store.getters.adminID
        var paras = {
            timestamp: rsa.encryptString(String(publicFun.gettimestamp()), rsaBasicModuleConfig.serverPublicKey),
            // v +AdminToken +notice_type + MKBPLDNB
            _sign: rsa.signString(baseconfig.v + adminToken + "~ACfasd", rsaBasicModuleConfig.clientPrivateKey),
        }
        return await httpRequest(baseUrl.basic + 'systemmessageinfolist?page=' + page + '&pagesize=' + pagesize + '&key_words=' + key_words + '&timestamp=' + encodeURIComponent(paras.timestamp) + '&_sign=' + encodeURIComponent(paras._sign), 'get', null, null)
    },
    // 获取详情
    async systemmessageinfomodel(message_id) {
        const adminToken = store.getters.adminID
        var paras = {
            timestamp: rsa.encryptString(String(publicFun.gettimestamp()), rsaBasicModuleConfig.serverPublicKey),
            // v +AdminToken+notice_id + ddsfgh8JK  
            _sign: rsa.signString(baseconfig.v + adminToken + message_id + '~JA698f44DI9', rsaBasicModuleConfig.clientPrivateKey)
        }
        // console.log(paras)
        return await httpRequest(baseUrl.basic + 'systemmessageinfomodel?message_id=' + message_id + '&timestamp=' + encodeURIComponent(paras.timestamp) + '&_sign=' + encodeURIComponent(paras._sign), 'get', null, null)
    },
    // 获取内容详情
    async systemmessageinfocontent(message_id) {
        const adminToken = store.getters.adminID
        var paras = {
            timestamp: rsa.encryptString(String(publicFun.gettimestamp()), rsaBasicModuleConfig.serverPublicKey),
            // v +AdminToken+notice_id + ddsfgh8JK  
            _sign: rsa.signString(baseconfig.v + adminToken + message_id + '~JA6987cI9', rsaBasicModuleConfig.clientPrivateKey)
        }
        // console.log(paras)
        return await httpRequest(baseUrl.basic + 'systemmessageinfocontent?message_id=' + message_id + '&timestamp=' + encodeURIComponent(paras.timestamp) + '&_sign=' + encodeURIComponent(paras._sign), 'get', null, null)
    },
    // 公告添加
    async addsystemmessageinfo(title, content, target_type) {
        const adminToken = store.getters.adminID
        var paras = {
            title: title,
            target_type: target_type,
            content: content,
            timestamp: rsa.encryptString(String(publicFun.gettimestamp()), rsaBasicModuleConfig.serverPublicKey),
            _sign: rsa.signString(baseconfig.v + adminToken + target_type + "19f68xc65465", rsaBasicModuleConfig.clientPrivateKey)
        }
        console.log(baseconfig.v + adminToken + target_type + "19f68xc65465")
        return await httpRequest(baseUrl.basic + 'addsystemmessageinfo', 'put', qs.stringify(paras), null)
    },
    //公告编辑
    async editsystemmessageinfo(message_id, title, target_type, content, original_value_json) {
        const adminToken = store.getters.adminID
        var paras = {
            message_id: message_id,
            title: title,
            target_type: target_type,
            content: content,
            original_value_json: original_value_json,
            timestamp: rsa.encryptString(String(publicFun.gettimestamp()), rsaBasicModuleConfig.serverPublicKey),
            // v +AdminToken+notice_id+notice_type+ jfhr43FF 
            _sign: rsa.signString(baseconfig.v + adminToken + String(message_id) + String(target_type) + '~ASDQ123324', rsaBasicModuleConfig.clientPrivateKey)
        }
        return await httpRequest(baseUrl.basic + 'editsystemmessageinfo', 'post', qs.stringify(paras), null)
    },
    //公告删除
    async delsystemmessageinfo(message_id) {
        const adminToken = store.getters.adminID
        var paras = {
            message_id: message_id,
            timestamp: rsa.encryptString(String(publicFun.gettimestamp()), rsaBasicModuleConfig.serverPublicKey),
            // v +AdminToken+notice_id+ MBIM#N58ndks 
            _sign: rsa.signString(baseconfig.v + adminToken + String(message_id) + 'djsej@2dfs', rsaBasicModuleConfig.clientPrivateKey)
        }
        return await httpRequest(baseUrl.basic + 'delsystemmessageinfo', 'post', qs.stringify(paras), null)
    },

}
// 公告管理
export const indexnoticeModule = {
    // 获取公告列表
    // /indexnoticeinfolist
    async getNoticeList(page, page_size, notice_title, notice_type) {
        const adminToken = store.getters.adminID
        var paras = {
            timestamp: rsa.encryptString(String(publicFun.gettimestamp()), rsaBasicModuleConfig.serverPublicKey),
            // v +AdminToken +notice_type + MKBPLDNB
            _sign: rsa.signString(baseconfig.v + adminToken + notice_type + "MKBPLDNB", rsaBasicModuleConfig.clientPrivateKey),
        }
        return await httpRequest(baseUrl.basic + 'indexnoticeinfolist?page=' + page + '&age_size=' + page_size + '&notice_title=' + notice_title + '&notice_type=' + notice_type + '&timestamp=' + encodeURIComponent(paras.timestamp) + '&_sign=' + encodeURIComponent(paras._sign), 'get', null, null)
    },
    // 获取公告详情
    // /indexnoticeinfomodel
    async getNoticeDetails(notice_id) {
        const adminToken = store.getters.adminID
        var paras = {
            timestamp: rsa.encryptString(String(publicFun.gettimestamp()), rsaBasicModuleConfig.serverPublicKey),
            // v +AdminToken+notice_id + ddsfgh8JK  
            _sign: rsa.signString(baseconfig.v + adminToken + notice_id + 'ddsfgh8JK', rsaBasicModuleConfig.clientPrivateKey)
        }
        // console.log(paras)
        return await httpRequest(baseUrl.basic + 'indexnoticeinfomodel?notice_id=' + notice_id + '&timestamp=' + encodeURIComponent(paras.timestamp) + '&_sign=' + encodeURIComponent(paras._sign), 'get', null, null)
    },


}
//广告管理
export const advertModule = {
    // 广告列表 --HYT
    async advertinfolist(page, pagesize, advert_type, is_show, module_id, advert_title) {
        const adminToken = store.getters.adminID
        var paras = {
            timestamp: rsa.encryptString(String(publicFun.gettimestamp()), rsaBasicModuleConfig.serverPublicKey),
            // v + AdminToken + advert_type + is_show + module_id + "~516sad"
            _sign: rsa.signString(baseconfig.v + adminToken + String(advert_type) + String(is_show) + String(module_id) + "~516sad", rsaBasicModuleConfig.clientPrivateKey),
        }
        return await httpRequest(baseUrl.basic + 'advertinfolist?page=' + page + '&pagesize=' + pagesize + '&advert_title=' + advert_title + '&advert_type=' + advert_type + '&is_show=' + is_show + '&module_id=' + module_id + '&timestamp=' + encodeURIComponent(paras.timestamp) + '&_sign=' + encodeURIComponent(paras._sign), 'get', null, null)
    },
    // 获取内容详情
    async advertinfocontent(advert_id) {
        const adminToken = store.getters.adminID
        var paras = {
            timestamp: rsa.encryptString(String(publicFun.gettimestamp()), rsaBasicModuleConfig.serverPublicKey),
            // v +AdminToken+notice_id + ddsfgh8JK  
            _sign: rsa.signString(baseconfig.v + adminToken + advert_id + '~J123cI9', rsaBasicModuleConfig.clientPrivateKey)
        }
        // console.log(paras)
        return await httpRequest(baseUrl.basic + 'advertinfocontent?advert_id=' + advert_id + '&timestamp=' + encodeURIComponent(paras.timestamp) + '&_sign=' + encodeURIComponent(paras._sign), 'get', null, null)
    },
    //广告详情 HYT
    async advertinfomodel(advert_id) {
        const adminToken = store.getters.adminID
        var paras = {
            timestamp: rsa.encryptString(String(publicFun.gettimestamp()), rsaBasicModuleConfig.serverPublicKey),
            _sign: rsa.signString(baseconfig.v + adminToken + String(advert_id) + '~JA6989', rsaBasicModuleConfig.clientPrivateKey)
        }
        // console.log(paras)
        return await httpRequest(baseUrl.basic + 'advertinfomodel?advert_id=' + advert_id + '&timestamp=' + encodeURIComponent(paras.timestamp) + '&_sign=' + encodeURIComponent(paras._sign), 'get', null, null)
    },
    // 添加广告 --HYT
    async addadvertinfo(advert_title, img_url, advert_content, advert_type, key_id, module_id, is_show, link_url, order_weight) {
        const adminToken = store.getters.adminID
        var paras = {
            advert_title: advert_title,
            img_url: img_url,
            advert_content: advert_content,
            advert_type: advert_type,
            key_id: key_id,
            module_id: module_id,
            is_show: is_show,
            link_url: link_url,
            order_weight: order_weight,
            timestamp: rsa.encryptString(String(publicFun.gettimestamp()), rsaBasicModuleConfig.serverPublicKey),
            //v +AdminToken+notice_type+ jyrd43FF
            _sign: rsa.signString(baseconfig.v + adminToken + String(advert_type) + String(module_id) + String(is_show) + "19f6asd5", rsaBasicModuleConfig.clientPrivateKey)
        }
        return await httpRequest(baseUrl.basic + 'addadvertinfo', 'put', qs.stringify(paras), null)
    },
    //编辑广告 --HYT
    async editadvertinfo(advert_id, advert_title, img_url, advert_content, advert_type, key_id, module_id, is_show, order_weight, link_url, original_value_json) {
        const adminToken = store.getters.adminID
        var paras = {
            advert_id: advert_id,
            advert_title: advert_title,
            img_url: img_url,
            advert_content: advert_content,
            advert_type: advert_type,
            key_id: key_id,
            module_id: module_id,
            is_show: is_show,
            order_weight: order_weight,
            link_url: link_url,
            original_value_json: original_value_json,
            timestamp: rsa.encryptString(String(publicFun.gettimestamp()), rsaBasicModuleConfig.serverPublicKey),
            // v +AdminToken+notice_id+notice_type+ jfhr43FF 
            _sign: rsa.signString(baseconfig.v + adminToken + String(advert_id) + String(advert_type) + String(module_id) + String(is_show) + String(order_weight) + '~123ACf', rsaBasicModuleConfig.clientPrivateKey)
        }
        return await httpRequest(baseUrl.basic + 'editadvertinfo', 'post', qs.stringify(paras), null)
    },
    //删除广告--HYT
    async deladverinfo(advert_id) {
        const adminToken = store.getters.adminID
        var paras = {
            advert_id: advert_id,
            timestamp: rsa.encryptString(String(publicFun.gettimestamp()), rsaBasicModuleConfig.serverPublicKey),
            // v +AdminToken+notice_id+ MBIM#N58ndks 
            _sign: rsa.signString(baseconfig.v + adminToken + String(advert_id) + 'djsej@2dfs', rsaBasicModuleConfig.clientPrivateKey)
        }
        return await httpRequest(baseUrl.basic + 'deladverinfo', 'post', qs.stringify(paras), null)
    },
}
// 
export const parentregioninfoModule = {
    // /parentregioninfo
    async parentregioninfo() {
        const adminToken = store.getters.adminID

        var paras = {
            timestamp: rsa.encryptString(String(publicFun.gettimestamp()), rsaBasicModuleConfig.serverPublicKey),
            _sign: rsa.signString(baseconfig.v + String(adminToken) + 'dsmfdjs', rsaBasicModuleConfig.clientPrivateKey)
        }
        return await httpRequest(baseUrl.basic + 'parentregioninfo?timestamp=' + encodeURIComponent(paras.timestamp) + '&_sign=' + encodeURIComponent(paras._sign), 'get', null, null)
    }
}

//业务时间管理
export const biztimeModule = {
    // 业务时间设置列表--CXM
    async getBiztimeList(audit_year) {
        const adminToken = store.getters.adminID
        var paras = {
            timestamp: rsa.encryptString(String(publicFun.gettimestamp()), rsaBasicModuleConfig.serverPublicKey),
            _sign: rsa.signString(baseconfig.v + adminToken + 'sasjkfjd', rsaBasicModuleConfig.clientPrivateKey),
        }
        return await httpRequest(baseUrl.basic + 'v2/biztimesetlist?timestamp=' + encodeURIComponent(paras.timestamp) + '&_sign=' + encodeURIComponent(paras._sign) + '&audit_year=' + audit_year, 'get', null, null)
    },
    // 业务时间设置-保存--CXM
    async biztimesetinfosave(start_time, end_time, policy_measure_id, audit_year) {
        const adminToken = store.getters.adminID
        var paras = {
            start_time: start_time,
            end_time: end_time,
            policy_measure_id: policy_measure_id,
            audit_year: audit_year,
            timestamp: rsa.encryptString(String(publicFun.gettimestamp()), rsaBasicModuleConfig.serverPublicKey),
            _sign: rsa.signString(baseconfig.v + adminToken + String(policy_measure_id) + 'dddasdfe', rsaBasicModuleConfig.clientPrivateKey)
        }
        return await httpRequest(baseUrl.basic + 'v2/biztimesetinfosave', 'post', qs.stringify(paras), null)
    },
    // 业务时间设置-修改--CXM
    async biztimesetinfoedit(mark, biz_time_id) {
        const adminToken = store.getters.adminID
        var paras = {
            mark: mark,
            biz_time_id: biz_time_id,
            timestamp: rsa.encryptString(String(publicFun.gettimestamp()), rsaBasicModuleConfig.serverPublicKey),
            _sign: rsa.signString(baseconfig.v + adminToken + 'eeeasdfe', rsaBasicModuleConfig.clientPrivateKey)
        }
        return await httpRequest(baseUrl.basic + 'v2/biztimesetinfoedit', 'post', qs.stringify(paras), null)
    },


}
